<div title="{{item.value.label | translate}}" class="ui-multiselect-item-custom
                                    {{item.value.preferred?'multiselect-bg-white':'multiselect-bg-gray'}}
                                    {{item.separator?'item-separator':''}}">
  <div class="checkbox">
    <input type="checkbox" [checked]="item.isSelected" [disabled]="item.isReadOnly"/>
    <label class="ui-multiselect-option-label" [ngClass]="{'read-only':item.isReadOnly}">
      <span class="label-text">{{item.value.label | translate}}</span>
    </label>
  </div>
</div>
